import { Brightness6, BrightnessHigh, BrightnessLow } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import type { DeviceBulkSelectionInput } from '~/generated/graphql';
import { DeviceCommandKind } from '~/generated/graphql';
import { DeviceSliderDialog } from './DeviceSliderDialog';

interface BrightnessDialogProps {
  onClose: () => void;
  onComplete?: () => void;
  open: boolean;
  selected: DeviceBulkSelectionInput;
}

export const BrightnessDialog = ({
  onClose,
  onComplete,
  open,
  selected,
}: BrightnessDialogProps) => {
  const { t } = useTranslation();

  return (
    <DeviceSliderDialog
      onClose={onClose}
      onComplete={onComplete}
      open={open}
      selected={selected}
      command={DeviceCommandKind.Brightness}
      defaultValue={50}
      Icon={Brightness6}
      title={t('pages.devices.dialogs.brightness.title')}
      buttonText={t('pages.devices.dialogs.brightness.set_button')}
      LeftIcon={BrightnessLow}
      RightIcon={BrightnessHigh}
    />
  );
};
